export enum EnumPartialRoutes {
  AUTHENTICATION = 'authentication',
  SCHEDULE = 'schedule',
  SCHEDULE_DAY_VIEW = 'schedule/day-view',
  MEDICAL_RECORD = 'medical_record',
  TREATMENT_HISTORY = 'treatment_history',
  EXTERNAL = 'external'
}

export enum EnumRoutes {
  LOGIN = 'login',
  FORGOT_PASSWORD = 'forgot_password',
  CREATE_PASSWORD = 'create_password',
  SCHEDULE = 'schedule',
  ANAMNESIS = 'anamnesis',
  MEDICAL_RECORD = 'medical_record',
  EXAM_RESULTS = 'exam_results'
}

export enum EnumProfiles {
  Admin = 'administrador',
  Doctor = 'medico',
  Nurse = 'enfermagem',
  Nutrition = 'nutricao',
  Pharmacy = 'farmacia',
  Psychology = 'psicologia',
}

export const fullRoutes = {
  LOGIN: `/${EnumPartialRoutes.AUTHENTICATION}/${EnumRoutes.LOGIN}`,
  ANAMNESIS: `/${EnumPartialRoutes.MEDICAL_RECORD}/${EnumRoutes.ANAMNESIS}`,
  FORGOT_PASSWORD: `/${EnumPartialRoutes.AUTHENTICATION}/${EnumRoutes.FORGOT_PASSWORD}`,
}

export enum LogoutMethod {
  INACTIVITY = 'inactivity',
  DEFAULT = 'default'
}
